(function () {
  function initVideoObserver(root) {
    root = root || document;

    var videos = root.querySelectorAll('.product-item__hover-video');
    console.log('[VideoObserver] Video trovati:', videos.length);

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var video = entry.target;
        if (entry.isIntersecting) {
          if (!video.src && video.dataset.src) {
            video.src = video.dataset.src;
          }
          video.play().catch(function () {});
        } else {
          video.pause();
          video.currentTime = 0;
        }
      });
    }, {
      threshold: 0.3 // parte quando il 30% del video è visibile
    });

    videos.forEach(function (video) {
      if (video.dataset.observerInit) return;
      video.dataset.observerInit = '1';
      observer.observe(video);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initVideoObserver();
  });

  document.addEventListener('shopify:section:load', function () { initVideoObserver(); });
  document.addEventListener('collection:updated', function () { initVideoObserver(); });
})();